import { render, staticRenderFns } from "./HostingIpAddr.vue?vue&type=template&id=4848d86a&"
import script from "./HostingIpAddr.vue?vue&type=script&lang=js&"
export * from "./HostingIpAddr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4848d86a')) {
      api.createRecord('4848d86a', component.options)
    } else {
      api.reload('4848d86a', component.options)
    }
    module.hot.accept("./HostingIpAddr.vue?vue&type=template&id=4848d86a&", function () {
      api.rerender('4848d86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/common/HostingIpAddr.vue"
export default component.exports